import { render, staticRenderFns } from "./appUp.vue?vue&type=template&id=6c99aba1&scoped=true&"
import script from "./appUp.vue?vue&type=script&lang=js&"
export * from "./appUp.vue?vue&type=script&lang=js&"
import style0 from "./appUp.vue?vue&type=style&index=0&id=6c99aba1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99aba1",
  null
  
)

export default component.exports